/** ข้อความและค่าคงที่ของ MFA ที่ใช้ร่วมกันระหว่าง login กับ panel */

import type { MfaFailure } from './mfaClient';

export const MFA_CODE_LENGTH = 6;

export const MFA_REJECTED_MESSAGE =
  'รหัสไม่ถูกต้อง หรือรหัสยืนยันหมดอายุ/ถูกใช้ไปแล้ว หรือบัญชีถูกล็อกชั่วคราว — ลองอีกครั้ง หากยังไม่ได้ผลให้เริ่มเข้าสู่ระบบใหม่';

export function describeMfaFailure(failure: MfaFailure): string {
  switch (failure) {
    case 'rejected':
      return MFA_REJECTED_MESSAGE;
    case 'code-invalid':
      return 'รหัส 6 หลักไม่ถูกต้อง — ตรวจเวลาของโทรศัพท์แล้วลองใหม่ (การกรอกผิดซ้ำจะทำให้บัญชีถูกล็อกชั่วคราว)';
    case 'current-code-required':
      return 'ต้องกรอกรหัส 6 หลักปัจจุบันจากแอปยืนยันตัวตนก่อน';
    case 'one-code-required':
      return 'กรอกรหัสอย่างใดอย่างหนึ่ง: รหัส 6 หลัก หรือรหัสกู้คืน';
    case 'unavailable':
      return 'ระบบ MFA ยังไม่พร้อมใช้งานบนเซิร์ฟเวอร์นี้ — แจ้งผู้ดูแลระบบ';
    case 'bad-request':
      return 'คำขอไม่ถูกรูปแบบ — ตรวจรหัสที่กรอกแล้วลองใหม่';
    case 'server-error':
      return 'เซิร์ฟเวอร์ตอบผิดพลาด — ยังดำเนินการไม่ได้';
    case 'network-error':
      return 'ติดต่อเซิร์ฟเวอร์ไม่ได้ — ยังดำเนินการไม่ได้';
    case 'invalid-response':
      return 'คำตอบจากเซิร์ฟเวอร์ผิดรูปแบบ — ยังดำเนินการไม่ได้';
  }
}
